<div class="top-shift">
    <pcg-bounce-alert></pcg-bounce-alert>

    <!-- Non-admin dashboard -->
    @if (!isAdmin) {
        <div>
            <div class="row event-indicator-ctnr">
                <div class="event-indicator">
                    <fa-icon [icon]="faIconName.faVirus" class="fa-xl mr-2"></fa-icon>
                    <h3>{{ eventName }}</h3>
                </div>
            </div>
            <div class="d-flex flex-row-reverse">
                <div class="dashboard-container">
                    <img #img class="img-fluid" src="assets/images/logos/logo.png" draggable="false" />
                </div>
            </div>
        </div>
    }

    <!-- Admin dashboard -->
    @if (isAdmin) {
        <div class="dashboard">
            <div class="row event-indicator-ctnr">
                <div class="event-indicator">
                    <fa-icon [icon]="faIconName.faVirus" class="fa-xl mr-2"></fa-icon>
                    <h3>{{ eventName }}</h3>
                </div>
            </div>
            <div class="count-ctnr">
                <pcg-daily-count-status></pcg-daily-count-status>
            </div>
            <div class="count-ctnr">
                <pcg-daily-count-weekly></pcg-daily-count-weekly>
                <pcg-business-days></pcg-business-days>
            </div>
            <div class="bottomLogo">
                <img #img class="img-fluid" src="assets/images/logos/logo.png" draggable="false" />
            </div>
        </div>
    }
</div>
